const PRINTABLE_ASCII = /^[\x20-\x7e]*$/;
export function isPrintableASCII(value: string): boolean {
  return PRINTABLE_ASCII.test(value);
}

export const SCENARIO_NAME_LENGTH: number = 60;
export const YEAR_TEXT_LENGTH: number = 4;
